// HazardSelectingTable.tsx
import React, { useEffect, useState, useRef, ChangeEvent } from "react";
import { DownIcon, UpIcon } from "../../iconSet/IconSet";

export type HazardType = {
	code: string;
	name: string;
};

type HazardSelectingTableProps = {
	onSelectHazards: (selectedHazards: HazardType[]) => void;
	 hazards: string[];
};

const hazardTypes: HazardType[] = [
	{ code: "LSW", name: "Landslide" },
	{ code: "FLW", name: "Flood" },
	{ code: "HRW", name: "Heavy Rain" },
	{ code: "EW", name: "Explosion" },
	{ code: "TW", name: "Tsunami" },
	{ code: "BHW", name: "Biological Hazard" },
	{ code: "FW", name: "Fire" },
	{ code: "CW", name: "Cyclone" },
	{ code: "WFW", name: "Wild Fire" },
	{ code: "EQW", name: "Earthquake" },
	{ code: "HWN", name: "High Wind" },
	{ code: "MWA", name: "Marine Weather" },
	{ code: "NTW", name: "Nuclear Threat" },
	{ code: "ASW", name: "Air Strike" },
	{ code: "LIG", name: "Lightning" },
];

const HazardsTable = (props: HazardSelectingTableProps) => {
	const [numberOfRows, setNumberOfRows] = useState<number>(7);
	const [selectedCodes, setSelectedCodes] = useState<Set<string>>(new Set());
	const [filterTableData, setFilterTableData] = useState<HazardType[]>([]);
	const [pagination, setPagination] = useState<HazardType[][]>([]);
	const [selectedPagination, setSelectedPagination] = useState<number>(0);

	const sliceCountRef = useRef<HTMLInputElement>(null);
	const searchRef = useRef<HTMLInputElement>(null);

	// true = A -> Z
	// false = Z -> A
	const [hazardNameSort, setHazardNameSort] = useState<Boolean>(true)
	const hazardNameSortHandle = () => {
		setHazardNameSort(prevState => !prevState)
	}
	useEffect(() => {
		setFilterTableData(prevState => {
			return [...prevState].sort((a, b) => {
				const hazardNameComparison = hazardNameSort ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
				return hazardNameComparison
			})
		})
	}, [hazardNameSort])

 /* useEffect(() => {
	if (!Array.isArray(props.hazards) || props.hazards.length === 0) return;
	console.log("props.hazards : ",props.hazards)

	const hazardCodes = props.hazards.filter(code => typeof code === "string");

	const incomingSet = new Set(hazardCodes);

	const areEqual =
		incomingSet.size === selectedCodes.size &&
		hazardCodes.every((code) => selectedCodes.has(code));

	if (!areEqual) {
		setSelectedCodes(incomingSet);
	}
}, [props.hazards]); */

	useEffect(() => {
		if (props.hazards && props.hazards.length > 0) {
			const incomingSet = new Set(props.hazards);
			const areEqual =
				props.hazards.length === selectedCodes.size &&
				props.hazards.every((code) => selectedCodes.has(code));

			if (!areEqual) {
				setSelectedCodes(incomingSet);
			}
		}
	}, [props.hazards]);

	useEffect(() => {
		setFilterTableData(prevState => {
			return [...hazardTypes].sort((a, b) => {
				const hazardNameComparison = hazardNameSort ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
				return hazardNameComparison
			})
		})
	}, []);

	useEffect(() => {
		const pages: HazardType[][] = [];
		for (let i = 0; i < filterTableData.length; i += numberOfRows) {
			pages.push(filterTableData.slice(i, i + numberOfRows));
		}
		setPagination(pages);
		setSelectedPagination(0);
	}, [filterTableData, numberOfRows]);

	/* const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
		const code = event.target.name;
		const updated = new Set(selectedCodes);

		if (event.target.checked) {
			updated.add(code);
		} else {
			updated.delete(code);
		}

		setSelectedCodes((prev) => {
			const next = new Set(prev);
			if (event.target.checked) {
				next.add(code);
			} else {
				next.delete(code);
			}

			const selectedHazards = hazardTypes.filter((hazard) =>
				next.has(hazard.code)
			);

			props.onSelectHazards(selectedHazards);

			return next;
		});
	}; */

	useEffect(() => {
		const selectedHazards = hazardTypes.filter((hazard) =>
			selectedCodes.has(hazard.code)
		);
		props.onSelectHazards(selectedHazards);
	}, [selectedCodes]);

	const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
	const code = event.target.name;

	setSelectedCodes((prev) => {
		const updated = new Set(prev);
		if (event.target.checked) {
			updated.add(code);
		} else {
			updated.delete(code);
		}
		return updated;
	});
};

	const handleSliceCountChange = (e: ChangeEvent<HTMLInputElement>) => {
		const value = Number(e.target.value);
		if (value > 0) setNumberOfRows(value);
	};

	const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
		const searchText = event.target.value.toLowerCase();
		if (!searchText) {
			setFilterTableData(hazardTypes);
		} else {
			setFilterTableData(
				hazardTypes.filter((hazard) =>
					hazard.name.toLowerCase().includes(searchText)
				)
			);
		}
	};

	const paginationNavigation = (direction: "next" | "prev") => {
		if (direction === "next" && selectedPagination + 1 < pagination.length) {
			setSelectedPagination((prev) => prev + 1);
		} else if (direction === "prev" && selectedPagination > 0) {
			setSelectedPagination((prev) => prev - 1);
		}
	};

	const handleSelectAllCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
		const isChecked = event.target.checked

		setSelectedCodes(() => {
			if (isChecked) {
			  return new Set(hazardTypes.map((hazard) => hazard.code));
			} else {
			  return new Set();
			}
		});
	}

	return (
		<div style={{ height:'100%', width: '100%'}} className="subTable-wrapper">
			<span className="main-title">Select Hazard Types</span>
			<div className="field-wrapper">
				<div className="left">
					<span>
						Show{" "}
						<input style={{ width: "3rem" }} type="number" ref={sliceCountRef} defaultValue={numberOfRows} min={1} onChange={handleSliceCountChange} />{" "} entries
					</span>
				</div>
				<div className="right">
					<span>
						Search{" "}
						<input type="text" ref={searchRef} onChange={handleSearchChange} placeholder="Search here" />
					</span>
				</div>
			</div>

		<div className="table-body" style={{width: '100%'}}>
			<div className="table-wrapper" style={{ width: '100%' }}>
				<div className="table-row header" style={{ gridTemplateColumns: `4rem 1fr`, width: '100%' }} >
					<span style={{ width: '100%' }}>
						<input type="checkbox" className='select-all-checkbox' onChange={(e) => handleSelectAllCheckbox(e)}/>
					</span>
					<span style={{ width: '100%' }} onClick={(e) => hazardNameSortHandle()}>
						Hazard Name
						<div>
							{hazardNameSort ? (
								<UpIcon width="1rem" color="var(--color-main-white)" />
							) : (
								<DownIcon width="1rem" color="var(--color-main-white)" />
							)}
							
						</div>
					</span>
				</div>

				{pagination[selectedPagination]?.map((hazard, index) => (
					<div key={index} className='table-wrapper' style={{ width: '100%' }}>
					<div className="table-row" key={hazard.code} style={{ gridTemplateColumns: `4rem 1fr`, width: '100%' }}>
						<span style={{ justifyContent: "center" }}>
							<input
								type="checkbox"
								name={hazard.code}
								checked={selectedCodes.has(hazard.code)}
								onChange={handleCheckboxChange}
							/>
						</span>
						<span>{hazard.name ? hazard.name : 'N/A'}</span>
					</div>
					</div>
				))}

				{pagination.length === 0 && (
					<div className="table-no-data-wrapper">
						<span>No hazards available</span>
					</div>
				)}
			</div>
		</div>
			

			<div className="table-pagination-wrapper">
				<div
					style={{ margin: "0 0.25rem" }}
					className="icon-page-box"
					onClick={() => paginationNavigation("prev")}
				>
					&lt;
				</div>
				{pagination.map((_, idx) => (
					<span
						style={{ margin: "0 0.25rem" }}
						key={idx}
						className={
							selectedPagination === idx
								? "icon-page-box selected"
								: "icon-page-box"
						}
						onClick={() => setSelectedPagination(idx)}
					>
						{idx + 1}
					</span>
				))}
				<div
					style={{ margin: "0 0.25rem" }}
					className="icon-page-box"
					onClick={() => paginationNavigation("next")}
				>
					&gt;
				</div>
			</div>
		</div>
	);
};

export default HazardsTable;
